import { useEffect, useState } from "react";

const useValidateForm = (formData, schema) => {
  const [isValid, setIsValid] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    const validateForm = async () => {
      try {
        await schema.validate(formData, { abortEarly: false });
        setIsValid(true);
        setFieldErrors({});
      } catch (err) {
        if (err?.inner?.length > 0) {
          const errorMap = {};
          err.inner.forEach((error) => {
            if (error.path) errorMap[error.path] = error.message;
          });
          setFieldErrors(errorMap);
          setIsValid(false);
        }
      }
    };
    validateForm();
  }, [formData]);

  return { isValid, fieldErrors };
};

export default useValidateForm;
